function countdown(counterDiv = '.counter') {
    var main, endDate, returnCalculate;

    // Selecionar a div principal
    main = document.querySelectorAll(counterDiv);
    if (main.length === 0) return false;

    // Seleciona a propriedade 'data-deadline' e faz uma som para esperar o fim do dia
    endDate = main[0].getAttribute('data-deadline');
    if (endDate) endDate = endDate + 'T23:59:59-03:00';
    else return false;

    // Calcular e escrever
    returnCalculate = countdown_calculate(endDate, main);
    if( returnCalculate ) setInterval( () => countdown_calculate(endDate, main), 1000);

    return returnCalculate;
}

function countdown_calculate( endDate, main ) {
    var days, hours, minutes, seconds, endDate;

    endDate = new Date(endDate).getTime();
    if (isNaN(endDate)) return false;

    var startDate = new Date();
    startDate = startDate.getTime();

    var timeRemaining = parseInt((endDate - startDate) / 1000);

    // "Mágica" da matemática
    if (timeRemaining >= 0) {
        days = parseInt(timeRemaining / 86400);

        timeRemaining = (timeRemaining % 86400);
        hours = parseInt(timeRemaining / 3600);

        timeRemaining = (timeRemaining % 3600);
        minutes = parseInt(timeRemaining / 60);

        timeRemaining = (timeRemaining % 60);
        seconds = parseInt(timeRemaining);

        // Selecionar os filhos na div pai e escrever resultados
        main.forEach(element => {
            element.querySelector(".--days").textContent = days;
            element.querySelector(".--hours").textContent = ("0" + hours).slice(-2);
            element.querySelector(".--minutes").textContent = ("0" + minutes).slice(-2);
            element.querySelector(".--seconds").textContent = ("0" + seconds).slice(-2);
        });

        return true;
    } else {
        return false;
    }
}
